export default __webpack_public_path__ + "static/media/Dark.c12f656a.png";